/**
 * What the blog pages share about naming things: the slug a name or title
 * derives to, and how long a category name may be. Lives beside the list page
 * because that is where categories are made; the editor and its dialogs import
 * it from here rather than carrying copies.
 */

/**
 * What spark-blog accepts for a category name, mirrored here so the field
 * stops a long one being typed or pasted in the first place.
 *
 * Deliberately NOT also checked on save: the only value that could fail such a
 * check is a name stored before the cap existed, and blocking that would trap
 * the owner. The service lets an unchanged long name through precisely because
 * renaming it would re-slug the category and 404 every article published under
 * it.
 */
export const CATEGORY_NAME_MAX = 48;

/** kebab-case slug from a name or title (diacritics stripped, non-alphanumerics folded). */
export const slugify = (value: string): string =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
